import debounce from "./debounser.js";
import highlightMatches from "./highlightMatcher.js";
import Fuse from "fuse.js";

export const searchInputHandler = () => {
    const searchInputs = document.querySelectorAll(".header__search-input");
    const searchModal = document.querySelector(".search-modal");

    if (searchInputs.length > 0) {
        searchInputs.forEach(item => {
            item.addEventListener(
                "keydown",
                debounce(async event => {
                    const val = event.target?.value.toString().trim() || "";

                    if (val.length > 0) {

                        if (event.keyCode === 13) {
                            window.location.href = `/?s=${encodeURIComponent(val)}`
                        } else {
                            await fetch(
                                `${VARS.ajax_url
                                    .toString()
                                    .replace(
                                        "%%endpoint%%",
                                        "ems_sklad_search_handler"
                                    )}&s=${encodeURIComponent(val)}`
                            )
                                .then(r => r.text())
                                .then(html => {
                                    const searched = document.querySelectorAll("ul.search-results");
                                    if (searched) {
                                        searched.forEach(i => i.remove());
                                    }
                                    const parser = new DOMParser(),
                                        doc = parser.parseFromString(html, "text/html");

                                    const ul = doc.querySelector("ul.search-results");
                                    const allResultsLink = doc.querySelector(".all-results");

                                    if (ul) {
                                        const existingCategories = new Set();
                                        const categoryItems = ul.querySelectorAll(
                                            ".post-categories-list a"
                                        );

                                        categoryItems.forEach(categoryItem => {
                                            const categoryName = categoryItem.textContent.trim();
                                            if (existingCategories.has(categoryName)) {
                                                categoryItem.parentElement.remove();
                                            } else {
                                                existingCategories.add(categoryName);
                                            }
                                        });
                                        searchModal.appendChild(ul);
                                        searchModal.style.display = "block";
                                    }
                                });
                        }
                    } else {
                        const closeBtn=document.querySelector('.search-modal__close');
                        if (closeBtn) {
                            closeBtn.click();
                        }
                    }
                }, 500)
            );
        });
    }
};

export const wikiSearch = () => {
    const wikiSearchInput = document.querySelectorAll('[id^="wiki-search"]'),
        blocks = Array.from(
            document.querySelectorAll(".wikiPage__infoBlock") ?? []
        ).map(b => {
            return {
                element: b,
                title: b
                    .querySelector(".wikiPage__infoBlockTitle")
                    ?.textContent.replace(/\s{2,}/g, "")
                    .trim(),
                links: Array.from(b.querySelectorAll(".wikiPage__infoLink") ?? []).map(
                    l => l?.textContent.replace(/\s{2,}/g, "").trim()
                ),
            };
        }),
        options = {
            keys: ["title", "links"],
            threshold: 0.3,
        },
        fuse = new Fuse(blocks, options);
    if (wikiSearchInput.length) {
        wikiSearchInput.forEach(input => {
            input.addEventListener(
                "input",
                debounce(e => {
                    const filter = e.target.value,
                        results = fuse.search(filter);
                    if (!filter) {
                        blocks.forEach(block => {
                            block.element.style.display = "block";
                            highlightMatches(block.element, "");
                        });
                        return;
                    }

                    blocks.forEach(block => {
                        block.element.style.display = "none";
                    });
                    console.log(results);
                    results.forEach(({item}) => {
                        console.log(item);
                        item.element.style.display = "block";
                        highlightMatches(item.element, filter);
                    });
                }, 300)
            );
        });
    }
};
